<template>
  <!-- <basic-container > -->
  <div class="card-container" style="background: #f0f2f5">
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>超级智能体工作站</el-breadcrumb-item>
        <el-breadcrumb-item>减重智能体</el-breadcrumb-item>
        <el-breadcrumb-item>运动评估</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i class="el-icon-back" style="font-size: 20px; font-weight: bolder" @click="back()"></i>
      </el-breadcrumb>
    </div>
    <el-button-group>
      <el-button class="healthButton" @click="click(0)">数字档案</el-button>
      <el-button class="healthButton healthActive" @click="click(1)">运动评估</el-button>
      <el-button class="healthButton" @click="click(2)">运动处方</el-button>
      <el-button class="healthButton" @click="click(3)">营养处方</el-button>
      <el-button class="healthButton" @click="click(4)">行为认知治疗</el-button>
      <el-button class="healthButton" @click="click(5)">药物方案</el-button>
      <el-button class="healthButton" @click="click(6)">临床随访</el-button>
    </el-button-group>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 20px; font-weight: bold; margin-bottom: 2vh">
          {{ info.name }}
        </div>
        <div class="card03" style="font-size: 14px">
          <div>性别：{{ info.sex === 1 ? "男" : info.sex === 2 ? "女" : "未填写" }}</div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card03" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>身高|体重：{{ info.height ? info.height : " " }}cm/{{ info.weight ? info.weight : " " }}kg</div>
          <div>身份证号：{{ info.idCard }}</div>
        </div>
        <div class="card03" style="font-size: 14px; font-weight: bold">
          <!-- <div>报告生成时间：{{ body.report_time ? body.report_time : "用户未提交提交报告" }}</div> -->
        </div>
      </div>
    </div>

     <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">运动前评估</div>
        <div class="card04" style="font-size: 14px">
          <div>评估结果：{{ fitnessEvaluate ? fitnessEvaluate.motionBeforeEvaluate : "" }}</div>
        </div>
      </div>
    </div>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">人体成分分析</div>
        <div class="card04" style="font-size: 14px">
          <div>细胞内液：{{ body.R_ICW }}</div>
          <div>细胞外液：{{ body.R_ECW }}</div>
          <div>蛋白质：{{ body.R_PW }}</div>
          <div>无机盐：{{ body.R_IS }}</div>
        </div>
        <div class="card04" style="font-size: 14px">
          <div>体脂肪量：{{ body.R_Fat }}</div>
          <div>总水分：{{ body.R_TBW }}</div>
          <div>肌肉量：{{ body.R_SLM }}</div>
          <div>去脂体重：{{ body.R_FFM }}</div>
        </div>
        <!-- <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh; margin-top: 5vh;">肥胖分析</div>
        <div class="card03" style="font-size: 14px;">
          <div>身体质量指数：{{ body.R_BMI }}</div>
          <div>腰臀比：{{ body.R_WH }}</div>
          <div>内脏脂肪面积：{{ body.R_VFA }}</div>
        </div>

         <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh; margin-top: 5vh;">肌肉脂肪分析</div>
        <div class="card03" style="font-size: 14px">
          <div>体重：{{ body.R_Weight }}</div>
          <div>骨骼肌肉量：{{ body.R_BoneMuscle }}</div>
          <div>体脂肪量：{{ body.R_Fat }}</div>
        </div>

        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh; margin-top: 5vh;">节段肌肉分析</div>
        <div class="card04" style="font-size: 14px">
          <div>躯干：{{ body.R_MB ? body.R_MB + 'kg' : '' }}</div>
        </div>
        <div class="card04" style="font-size: 14px">
          <div>左臂：{{ body.R_ML ? body.R_ML + 'kg' : '' }}</div>
          <div>右臂：{{ body.R_MR ? body.R_MR + 'kg' : '' }}</div>
          <div>左腿：{{ body.R_MLL ? body.R_MLL + 'kg' : '' }}</div>
          <div>右腿：{{ body.R_MRL ? body.R_MRL + 'kg' : '' }}</div>
        </div>

         <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh; margin-top: 5vh;">体重控制</div>
        <div class="card04" style="font-size: 14px">
          <div>目标体重：{{ body.R_C_Object ? body.R_C_Object + 'kg' : '' }}</div>
        </div>
        <div class="card05" style="font-size: 14px">
          <div>体重控制：{{ body.R_C_Weight ? body.R_C_Weight + 'kg' : '' }}</div>
          <div>肌肉控制：{{ body.R_C_Muscle ? body.R_C_Muscle + 'kg' : '' }}</div>
          <div>脂肪控制：{{ body.R_C_Fat ? body.R_C_Fat + 'kg' : '' }}</div>
          <div>基础代谢量：{{ body.R_ExerciseTime }}</div>
          <div>四肢骨骼肌指数：{{ body.R_ASMI }}</div>
        </div>
        <div class="card-row" style="font-size: 15px; font-weight: bold;  margin-bottom: 2vh; margin-top: 5vh;">结论: {{ body.R_Comment }}</div> -->
      </div>
    </div>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">肥胖分析</div>
        <div class="card03" style="font-size: 14px">
          <div>身体质量指数：{{ body.R_BMI }}</div>
          <div>腰臀比：{{ body.R_WH }}</div>
          <div>内脏脂肪面积：{{ body.R_VFA }}</div>
        </div>
      </div>

      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">肌肉脂肪分析</div>
        <div class="card03" style="font-size: 14px">
          <div>体重：{{ body.R_Weight }}</div>
          <div>骨骼肌肉量：{{ body.R_BoneMuscle }}</div>
          <div>体脂肪量：{{ body.R_Fat }}</div>
        </div>
      </div>
    </div>

    <!-- <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">肌肉脂肪分析</div>
        <div class="card03" style="font-size: 14px">
          <div>体重：{{ body.R_Weight }}</div>
          <div>骨骼肌肉量：{{ body.R_BoneMuscle }}</div>
          <div>体脂肪量：{{ body.R_Fat }}</div>
        </div>
      </div>
    </div> -->

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">节段肌肉分析</div>
        <div class="card04" style="font-size: 14px">
          <div>躯干：{{ body.R_MB ? body.R_MB + "kg" : "" }}</div>
        </div>
        <div class="card04" style="font-size: 14px">
          <div>左臂：{{ body.R_ML ? body.R_ML + "kg" : "" }}</div>
          <div>右臂：{{ body.R_MR ? body.R_MR + "kg" : "" }}</div>
          <div>左腿：{{ body.R_MLL ? body.R_MLL + "kg" : "" }}</div>
          <div>右腿：{{ body.R_MRL ? body.R_MRL + "kg" : "" }}</div>
        </div>
      </div>
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">体重控制</div>
        <div class="card04" style="font-size: 14px">
          <div>目标体重：{{ body.R_C_Object ? body.R_C_Object + "kg" : "" }}</div>
        </div>
        <div class="card05" style="font-size: 14px">
          <div>体重控制：{{ body.R_C_Weight ? body.R_C_Weight + "kg" : "" }}</div>
          <div>肌肉控制：{{ body.R_C_Muscle ? body.R_C_Muscle + "kg" : "" }}</div>
          <div>脂肪控制：{{ body.R_C_Fat ? body.R_C_Fat + "kg" : "" }}</div>
          <div>基础代谢量：{{ body.R_ExerciseTime }}</div>
          <div>四肢骨骼肌指数：{{ body.R_ASMI }}</div>
        </div>
      </div>
    </div>

    <!-- <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">体重控制</div>
        <div class="card04" style="font-size: 14px">
          <div>目标体重：{{ body.R_C_Object ? body.R_C_Object + "kg" : "" }}</div>
        </div>
        <div class="card05" style="font-size: 14px">
          <div>体重控制：{{ body.R_C_Weight ? body.R_C_Weight + "kg" : "" }}</div>
          <div>肌肉控制：{{ body.R_C_Muscle ? body.R_C_Muscle + "kg" : "" }}</div>
          <div>脂肪控制：{{ body.R_C_Fat ? body.R_C_Fat + "kg" : "" }}</div>
          <div>基础代谢量：{{ body.R_ExerciseTime }}</div>
          <div>四肢骨骼肌指数：{{ body.R_ASMI }}</div>
        </div>
      </div>
    </div> -->

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 0vh">结论: {{ body.R_Comment }}</div>
      </div>
    </div>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">心肺适能评估</div>
        <div class="card04" style="font-size: 14px">
          <div>步行距离：{{ fitnessEvaluate ? fitnessEvaluate.experimentEvaluate.evaluateMeter + " 米" : "" }}（6分钟内累计预估步行距离）</div>
        </div>
        <div class="card04" style="font-size: 14px">
          <div>评估结果：{{ fitnessEvaluate ? fitnessEvaluate.experimentEvaluate.evaluateResult : "" }}</div>
          <div>评估标准：{{ fitnessEvaluate ? fitnessEvaluate.experimentEvaluate.evaluateStandard : "" }}</div>
          <div>评估建议：{{ fitnessEvaluate ? fitnessEvaluate.experimentEvaluate.evaluateDetail : "" }}</div>
        </div>
      </div>
    </div>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">肌肉适能评估</div>
        <div class="card04" style="font-size: 14px">
          <div>运动来源：{{ fitnessEvaluate ? fitnessEvaluate.muscleFitness.motionName : "" }}</div>
        </div>
        <div class="card04" style="font-size: 14px">
          <div>运动强度：{{ fitnessEvaluate ? fitnessEvaluate.muscleFitness.strength : "" }}</div>
          <div>1RM：{{ fitnessEvaluate ? fitnessEvaluate.muscleFitness.rm : "" }}</div>
        </div>
      </div>
    </div>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">柔韧适能评估</div>
      </div>
    </div>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 15px; font-weight: bold; margin-bottom: 2vh">平衡适能评估</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBodyDate, getFitnessEvaluate } from "@/api/health/manage";
import func from "@/util/func";

export default {
  name: "ThreeCardLayout",
  data() {
    return {
      wxUserId: this.$route.query.wxUserId,
      info: {},
      body: {},
      fitnessEvaluate: {},
    };
  },
  created() {},
  mounted() {
    this.onload();
  },
  methods: {
    onload() {
      const wxUserId = this.$route.query.wxUserId;
      getBodyDate(wxUserId).then((res) => {
        const wxUserId = window.localStorage.getItem("pcUserId");
        if (wxUserId === "2043870969731301377") {
          res.data.userJk.name = func.maskName(res.data.userJk.name);
          res.data.userJk.mobile = func.maskPhone(res.data.userJk.mobile);
        }
        this.info = res.data.userJk;
        console.log(res.data);
        this.body = res.data.medicalExaminationReport;
        // console.log(res.data.medicalExaminationReport);
      });

      getFitnessEvaluate(wxUserId).then((res) => {
        console.log("getFitnessEvaluate", res.data);
        this.fitnessEvaluate = res.data;
      });
    },

    click(index) {
      let path = "";
      switch (index) {
        case 0:
          // path = '/agent/digitalarchive'
          path = "/agent/dataarchive";
          break;
        case 1:
          path = "/agent/lossWeightBodyData";
          break;
        case 2:
          path = "/agent/homeMotion";
          break;
        case 3:
          path = "/agent/lossWeightClinicalExercise";
          break;
        case 4:
          path = "/agent/lossWeightCognitivebehaviorald";
          break;
        case 5:
          path = "/agent/lossWeightDrug";
          break;
        case 6:
          path = "/agent/lossWeightFollow";
          break;
      }
      const parameter = {
        wxUserId: this.wxUserId,
      };
      this.$router.push({
        path: path,
        query: parameter,
      });
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/agent/weightLoss",
      });
    },
  },
};
</script>

<style scoped>
.card-container {
  width: 100%;
  max-width: 100vw; /* 可根据需要调整最大宽度 */
  margin: 0 auto;
  padding: 1vw;
  box-sizing: border-box;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 10px;
}

.card-row2 {
  /* display: flex; */
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 1vw;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card01 {
  flex: 1;
  height: auto;
}

.card02 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 2vh;
}

.card03 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.card04 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.card05 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}
.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}
</style>
